import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export interface ActivityCode {
  id: number;
  code: string;
  name: string;
  description: string | null;
  utbmsTaskCode: string | null;
  utbmsActivityCode: string | null;
  utbmsExpenseCode: string | null;
  billableDefault: boolean;
  active: boolean;
}

export interface ActivityCodeInput {
  code: string;
  name: string;
  description?: string;
  billableDefault?: boolean;
}

export function useActivityCodes(includeInactive = false) {
  return useQuery<ActivityCode[]>({
    queryKey: ['activityCodes', includeInactive],
    queryFn: async () => {
      const { data } = await api.get('/api/activity-codes', {
        params: includeInactive ? { includeInactive: '1' } : {},
      });
      return data.items ?? [];
    },
    staleTime: 5 * 60_000,
  });
}

export function useCreateActivityCode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ActivityCodeInput) =>
      api.post('/api/activity-codes', body).then((r) => r.data.item),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['activityCodes'] }),
  });
}

export function useUpdateActivityCode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }: Partial<ActivityCodeInput> & { id: number }) =>
      api.patch(`/api/activity-codes/${id}`, body).then((r) => r.data.item),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['activityCodes'] }),
  });
}
